// extracted by mini-css-extract-plugin
export default {"detail":"Detail_detail__+dcLy","activitiesTitle":"Detail_activitiesTitle__z3wi3","activities":"Detail_activities__i8SqW","flag":"Detail_flag__X8lLO"};